import { pick } from 'lodash';
import { useEffect, useMemo } from 'react';
import isEqual from 'react-fast-compare';
import { useLocation } from 'react-use';
import { useAppDependencyGraphProvider } from '../../../../../context/DependencyGraphProvider';
import { ComputeContextKeys } from '../../../../../hooks/computeContext/const';
import { usePathParams } from '../../../../../hooks/usePathParams';
import {
  useGetGlobalAppStateStoreState,
  useGlobalAppStateStore,
} from '../../../../../stores/app/GlobalAppStateStore';

function useSetLocationInStore() {
  const { pathParams } = usePathParams();
  const location = useLocation();
  const { setLocation } = useGlobalAppStateStore().hooks.useActions();
  const { getGlobalAppStateStoreState } = useGetGlobalAppStateStoreState();
  const pickedLocation = useMemo(() => {
    return {
      ...pick(location, ['href', 'hostname', 'pathname', 'search', 'hash', 'origin']),
      pathParams,
    };
  }, [location, pathParams]);
  const {
    actions: { notifyDependencyChange },
  } = useAppDependencyGraphProvider();

  useEffect(() => {
    const locationInStore = getGlobalAppStateStoreState().location;
    if (!isEqual(pickedLocation, locationInStore)) {
      setLocation(pickedLocation);
      notifyDependencyChange({
        id: ComputeContextKeys.LOCATION,
      });

      // When the pathname changes, notify the interface record so that
      // active nav items are updated in interfacerecord
      if (
        !isEqual(pickedLocation.pathname, locationInStore.pathname) ||
        !locationInStore.pathname
      ) {
        notifyDependencyChange({
          id: ComputeContextKeys.INTERFACE_RECORD,
        });
      }
    }
  }, [getGlobalAppStateStoreState, pickedLocation, setLocation, notifyDependencyChange]);
}

export default useSetLocationInStore;
